import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AssistantDocumentDetailViewComponent } from '../../../../+assistant/assistant-overlays/overlays/assistant-document-detail-view/assistant-document-detail-view.component';
import { ViLoaderComponent } from '../../../../../projects/ui';
import { ServiceTicketStore } from '../../../../@store';
import { CommonStandaloneModule } from '../../../common-standalone.module';
import { ServiceTicketArticlesListComponent } from '../service-ticket-page-create/service-ticket-articles-list/service-ticket-articles-list.component';
import { AssistantStore } from 'src/app/@store/assistant';

@Component({
  selector: 'app-service-ticket-page-articles',
  standalone: true,
  imports: [
    CommonStandaloneModule,
    MatIconModule,
    MatButtonModule,
    ViLoaderComponent,
    AssistantDocumentDetailViewComponent,
    ServiceTicketArticlesListComponent,
  ],
  templateUrl: './service-ticket-page-articles.component.html',
  styleUrls: ['./service-ticket-page-articles.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceTicketPageArticlesComponent implements OnInit, OnDestroy {
  articleRated = false;
  boilerSerial: string;

  private ngUnsubscribe$ = new Subject<void>();

  constructor(
    public serviceTicketStore: ServiceTicketStore,
    public assistantStore: AssistantStore
  ) {}

  ngOnInit(): void {
    this.serviceTicketStore.requestRoutingProviderPayloadBoilerSerial$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((requestRoutingProviderPayloadBoilerSerial) => {
        this.boilerSerial = requestRoutingProviderPayloadBoilerSerial;
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  onCallNowClicked(): void {
    if (this.boilerSerial) {
      this.serviceTicketStore.requestRoutingProvider(this.boilerSerial);
    }
    this.serviceTicketStore.openCallPage();
  }

  rateArticle(isPositive: boolean): void {
    this.articleRated = true;
    this.serviceTicketStore.rateSelectedArticle(isPositive);
  }

  onPageChanged(): void {
    setTimeout(() => {
      document.querySelector('app-service-ticket-overlay').scrollTo(0, 0);
    }, 1);
  }

  onArticleSelected(): void {
    this.articleRated = false;
  }
}
